/*
 * A set of functions used throughout different modules
 */

(function ($, window, document, Handlebars, moment) {
    frk = window.frk || {};
    if (!console) {
        console = {};
        console.log = function () {
        };
    }

    /**
     * Constants
     */
    frk.MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    frk.MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    /*
     * Throttle function borrowed from:
     * Underscore.js 1.5.2
     * http://underscorejs.org
     * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
     * Underscore may be freely distributed under the MIT license.
     */
    frk.throttle = function (func, wait) {
        result = false;
        var timeout = null;
        var previous = 0;
        var later = function () {
            previous = new Date;
            timeout = null;
            result = func.apply(context, args);
        };
        return function () {
            var now = new Date;
            if (!previous)
                previous = now;
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0) {
                clearTimeout(timeout);
                timeout = null;
                previous = now;
                result = func.apply(context, args);
            } else if (!timeout) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    };

    /**
     * Delays the trigger of a function.
     * If the function is called twice within the timeout time specified,
     * it will only be called once,
     * unless it gets called again within the timeout time, etc...
     */
    frk.delay = function () {
        var timer = 0;
        return function (callback, ms) {
            window.clearTimeout(timer);
            timer = window.setTimeout(callback, ms);
        };
    }();

    frk.trimExtension = function (url, extension) {
        var a = (frk.UsConfig.getActor() === 'FA') ? '/advisor/' : '/investor/';
        return url.substring(0, url.indexOf(extension)).slice(url.indexOf(a));
    };


    frk.cache = {};
    /**
     * Ajax load html/json/etc... from url.
     *
     * @param {String} url The URL
     * @param {String} dataType The type of data to be loaded (html, json, etc...)
     * @param {Boolean} cache - cache the response for the url.
     * @returns {Promise} A promise
     */
    frk.load = function (url, dataType, cache) {
        var dfd = $.Deferred();
        if (cache && frk.cache[url] !== undefined) {
        	return frk.cache[url];
        } else {
        	if (cache) {
        		frk.cache[url] = dfd.promise();
        	}
            $.ajax({
                url: url,
                dataType: dataType
            }).done(function (data) {
                dfd.resolve(data);
            }).fail(function () {
                dfd.reject('Unable to load ' + dataType + 'at' + url);
                throw new DataLoadingException('Unable to load data: ' + url);
            });        	
        }

        return dfd.promise();
    };


    /**
     * Return an array of query strings (key/value)
     *
     * @returns {Array}
     */
    frk.getQueryStringParams = function (queryString) {
        var paramValue = window.location.search.substring(1).split('&'),
                params = [];

        if (paramValue && paramValue[0] !== '') {
            // get specific QS
            if (queryString) {
                params = '';
                for (var param = 0; param < paramValue.length; param++) {
                    var keyValueSplit = paramValue[param].split('=');
                    if (window.decodeURI(keyValueSplit[0]) === queryString) {
                        params = window.decodeURI(keyValueSplit[1]);
                    }
                }
            }
            // Return all
            else {
                params = [];
                for (var param = 0; param < paramValue.length; param++) {
                    var keyValueSplit = paramValue[param].split('=');

                    var keyValueObject = {
                        key: window.decodeURI(keyValueSplit[0]),
                        value: window.decodeURI(keyValueSplit[1])
                    };

                    params.push(keyValueObject);
                }
            }
        }

        return params;
    };


    /**
     * Loop through an array of object and return an array containing
     * unique a unique item list.
     *
     * @param {String} key The field to look at
     * @param {Array} entries An Array of objects
     * @returns {Array}
     */
    frk.getUnique = function (key, entries) {
        var u = {}, a = [];
        for (var entry in entries) {
            if (frk.getValueByString(entries[entry], key) && !u.hasOwnProperty(frk.getValueByString(entries[entry], key))) {
                a.push(frk.getValueByString(entries[entry], key));
                u[frk.getValueByString(entries[entry], key)] = true;
            }
        }
        return a;
    };

    /**
     * Get the current bootstrap grid size (xs, sm, md, lg)
     *
     * @returns {String}
     */

    frk.getCurrentGrid = function () {
        var gridSizes = ['xs', 'sm', 'md', 'lg'];

        var gridTester = document.createElement('div');
        var body = document.getElementsByTagName('body');

        body[0].appendChild(gridTester);

        gridTester = $(gridTester);

        for (var i = gridSizes.length - 1; i >= 0; i--) {
            var currentGrid = gridSizes[i];

            gridTester.addClass('hidden-' + currentGrid);
            if (gridTester.is(':hidden')) {
                gridTester.remove();
                return currentGrid;
            }
            ;
        }
        ;
    };

    frk.toCamelCase = function (string) {
        return string.replace(/-([a-z0-9])/g, function (g) {
            return g[1].toUpperCase();
        });
    };

    frk.toHyphens = function (string) {
        return string.replace(/([a-z][A-Z])/g, function (g) {
            return g[0] + '-' + g[1].toLowerCase();
        });
    };

    frk.replaceAll = function (str, find, replace) {
        return str.replace(new RegExp(frk.escapeRegExp(find), 'g'), replace);
    };

    frk.escapeRegExp = function (string) {
        return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    };


    /**
     * Takes and array of objects and removes entries that don't match the query.
     *
     * @param {String} query The string to filter element with
     * @param {Array} entries The array of object we want to filter
     * @param {Array} fields An array of keys
     * @returns {Array} result The result array after filtering
     */
    frk.filter = function (query, entries, fields) {
        // result array
        var result = [];
        // run through all entries
        for (var entry in entries) {
            //check all fields
            for (var field in fields) {
                if (typeof fields[field] === 'object') {

                    switch (fields[field].type) {
                        case 'array':
                            var p = frk.getValueByString(entries[entry], fields[field].parent);
                            if (p) {
                                for (var child in p) {
                                    try {
                                        // found it
                                        if (frk.getValueByString(p[child], fields[field].field).toLowerCase().indexOf(query.toLowerCase()) > -1) {
                                            result.push(entries[entry]);
                                            break; // no need to go further
                                        }
                                    }
                                    catch (err) {
                                        // fail in silence
                                        //console.error('Filtering error for fund ', entries[entry]);
                                    }
                                }
                            }
//                            console.log(fields[field].field)
                            break;
                    }
                }
                else {
                    try {
                        // found it
                        if (frk.getValueByString(entries[entry], fields[field]).toLowerCase().indexOf(query.toLowerCase()) > -1) {
                            result.push(entries[entry]);
                            break; // no need to go further
                        }
                    }
                    catch (err) {
                        // fail in silence
                        //console.error('Filtering error for fund ', entries[entry]);
                    }
                }
            }
        }

        return result;
    };
    
    /**
     * Takes and array of objects and removes entries that MATCH the query.
     *
     * @param {String} query The string to filter element with
     * @param {Array} entries The array of object we want to filter
     * @param {Array} fields An array of keys
     * @returns {Array} result The result array after filtering
     */
    frk.remove = function (query, entries, fields) {
        // result array
        var result = [];
        // run through all entries
        for (var entry in entries) {
            //check all fields
            for (var field in fields) {
                if (typeof fields[field] === 'object') {

                    switch (fields[field].type) {
                        case 'array':
                            var p = frk.getValueByString(entries[entry], fields[field].parent);
                            if (p) {
                                for (var child in p) {
                                    try {
                                        // found it
                                        if (frk.getValueByString(p[child], fields[field].field).toLowerCase().indexOf(query.toLowerCase()) > -1) {
                                            // element matched, so we don't add this to result
                                        }
                                        else
                                        {
                                            result.push(entries[entry]);
                                            break; // no need to go further
                                        }
                                    }
                                    catch (err) {
                                        // fail in silence
                                        //console.error('Filtering error for fund ', entries[entry]);
                                    }
                                }
                            }
//                            console.log(fields[field].field)
                            break;
                    }
                }
                else {
                    try {
                        // found it
                        if (frk.getValueByString(entries[entry], fields[field]).toLowerCase().indexOf(query.toLowerCase()) > -1) {
                             // element matched, so we don't add this to result
                        }
                        else
                        {
                            result.push(entries[entry]);
                            break; // no need to go further
                        }
                    }
                    catch (err) {
                        // fail in silence
                        //console.error('Filtering error for fund ', entries[entry]);
                    }
                }
            }
        }

        return result;
    };    


    /**
     * Can sort multiple queries in one pass
     *
     * @param {Array} fields An array of strings to filter elements with
     * @param {Array} entries The array of object we want to filter
     * @param {Array} queries An array of keys
     * @returns {Array} result The result array after filtering
     * 
     * The default logic operator is AND (&). 
     * If you want to check if a field is equal to x OR y, fields needs to be |x,y|
     * 
     * For example:
     *  fields= ["fundCategory.val", "shareClass.val"]
     *  entries = [Array of PPSS funds]
     *  queries = ["Asset Allocation", "|A,A1|"]
     *  
     *  This will return all funds with a fundCategory.val === "Asset Allocation"
     *  and shareClass.val === "A" OR shareClass.val === "A1"
     */
    frk.multiFilter = function (fields, entries, queries) {
        // result array
        var result = [], matchAll;
        // run through all entries
        for (var entry in entries) {
            // set counter to 0;
            matchAll = 0;
            //check all fields
            for (var query in queries) {
                // if OR query 
                if (queries[query].match(/^[|][^,]+(,[^,]+)*[|]$/)) {
                    var sqs = queries[query].substring(1, queries[query].length - 1).split(',');
                    try {
                        // matches
                        if (frk.getValueByString(entries[entry], fields[query])) {
                            for (var sp in sqs) {
                                if (frk.getValueByString(entries[entry], fields[query]).toLowerCase() === sqs[sp].toLowerCase()) {
                                    matchAll++;
                                    break;
                                }
                            }
                        }
                    }
                    catch (err) {
                        // fail in silence
                        //console.error('Filtering error for fund ', entries[entry]);
                    }
                }
                // basic query
                else {
                    try {
                        // matches
                        if (frk.getValueByString(entries[entry], fields[query]) && frk.getValueByString(entries[entry], fields[query]).toLowerCase() === queries[query].toLowerCase()) {
                            matchAll++;
                        }
                    }
                    catch (err) {
                        // fail in silence
                        //console.error('Filtering error for fund ', entries[entry]);
                    }
                }
            }
            // macth numbers is the same as queries length, so it's a match
            if (matchAll === fields.length) {
                result.push(entries[entry]);
            }
        }

        return result;
    };


    /**
     * A set of function to order array
     */
    frk.orderBy = {
        /**
         * Sorts an array of objects by alphabetical order
         *
         * @param {Array} entries an Array of objects
         * @param {String} field Optional. The field to sort on
         * @returns {Array} result A sorted Array of Objects
         */
        alphabetialOrder: function (entries, field) {
            entries.sort(function (a, b) {
                if (frk.getValueByString(a, field) < frk.getValueByString(b, field)) {
                    return -1;
                }
                if (frk.getValueByString(a, field) > frk.getValueByString(b, field)) {
                    return 1;
                }
                return 0;
            });
            return entries;
        },
        unalphabetialOrder: function (entries, field) {
            entries.sort(function (a, b) {
                if (frk.getValueByString(b, field) < frk.getValueByString(a, field)) {
                    return -1;
                }
                if (frk.getValueByString(b, field) > frk.getValueByString(a, field)) {
                    return 1;
                }
                return 0;
            });
            return entries;
        },
        /**
         * Sorts an array of objects by ascending order
         *
         * @param {Array} entries an Array of objects
         * @param {String} field Optional. The field to sort on
         * @returns {Array} result A sorted Array of Objects
         */
        ascendingOrder: function (entries, field) {
            entries.sort(function (a, b) {
                if (!isFinite(frk.getValueByString(a, field) - frk.getValueByString(b, field)))
                    return !isFinite(frk.getValueByString(a, field)) ? 1 : -1;
                else {
                    return frk.getValueByString(a, field) - frk.getValueByString(b, field);
                }
            });
            return entries;
        },
        descendingOrder: function (entries, field) {
            entries.sort(function (a, b) {
                if (!isFinite(frk.getValueByString(b, field) - frk.getValueByString(a, field)))
                    return !isFinite(frk.getValueByString(a, field)) ? 1 : -1;
                else {
                    return frk.getValueByString(b, field) - frk.getValueByString(a, field);
                }
            });
            return entries;
        }
    };

    /**
     * Reverse map of orderBy funtions
     */
    frk.orderBy.reverse = {
        alphabetialOrder: frk.orderBy.unalphabetialOrder,
        unalphabetialOrder: frk.orderBy.alphabetialOrder,
        ascendingOrder: frk.orderBy.descendingOrder,
        descendingOrder: frk.orderBy.ascendingOrder
    };


    /**
     * Accessing nested JavaScript objects with string key (something like key.otherKey)
     * Return the object itself if no key supllied.
     *
     * @param {type} object
     * @param {type} key Optional.
     * @returns {undefined}
     */
    frk.getValueByString = function (object, key) {
        if (key && key.length > 0) {
            var fields = key.split('.');
            for (var i = 0, n = fields.length; i < n; ++i) {
                var k = fields[i];
                try {
                    if (k in object) {
                        object = object[k];
                    } else {
                        return;
                    }
                }
                catch (err) {
                }
            }
        }
        return object;
    };


    /**
     * Helper to create realtime data rendering using jQuery and Hanldebars
     *
     * @param {Object} viewObject Where the view engine data is going to be stored
     * @returns {viewEngine} the view engine class
     */
    frk.viewEngine = function (viewObject) {

        /**
         * Reads the document and searches for data-view attributes.
         * Adds all of them in viewObject with following format
         */
        var init = function () {
            // we store all templates here
            viewObject._templates = {};
            $(document).find('[data-view]').each(function () {
                var cc = frk.toCamelCase($(this).data('view'));
                // chech if view id is not already in memory
                if (!viewObject._templates[cc]) {
                    viewObject._templates[cc] = {};
                    viewObject._templates[cc].element = [this];
                    viewObject._templates[cc].template = $(this).html();
                }
                // if it is, just add reference of dom element using it
                else {
                    viewObject._templates[cc].element.push(this);
                }
            });
            return this;
        };

        /**
         * Renders a specific element
         */
        var update = function (el) {
            try {
                $(viewObject._templates[el].element).html(viewObject[frk.toCamelCase(o)]());
            }
            catch (e) {
//                console.error(e);
            }
        };

        /**
         * Renders all view elements
         */
        var updateAll = function (reInit) {
            if (reInit)
                init();
            for (var o in viewObject._templates) {
                for (var e in viewObject._templates[o].element) {
                    try {
                        $(viewObject._templates[o].element[e]).html(viewObject[frk.toCamelCase(o)]());
                    }
                    catch (err) {
//                        console.error('error rendering ',o);
                    }
                }
            }
        };

        return {
            init: init,
            update: update,
            updateAll: updateAll
        };
    };

    //Return month id
    frk.moneyFund = function (data) {
        // sort table and put money fund at bottom
        // add a attr for first money fund first: true
        // remove attr first on others if any
        // in handlebars in repeat, if attr first and index not 1, then display headear (put in partial)

        // the queue where MF are going
        var queue = [];
        for (var f = 0; f < data.funds.length; f++) {
            if (data.funds[f].prntFundCategory &&
                    data.funds[f].prntFundCategory.val &&
                    data.funds[f].prntFundCategory.val === 'Money Funds') {
                // first MF, add special node to identify
                if (queue.length === 0) {
                    data.funds[f].firstMF = true;
                }
                // otherwise, remove firstMF node is any
                else {
                    delete data.funds[f].firstMF;
                }

                // add to queue
                queue.push(data.funds[f]);
                // remove from data
                data.funds.splice(f, 1);
                f--;
            }

        }
        // concat MF with data
        for (var q in queue) {
            data.funds.push(queue[q]);
        }
        return data;
    };

    //Return month id
    frk.getMonthId = function (month) {
        for (var i = 0; i < frk.MONTHS.length; i++) {
            if (month.toLowerCase() === frk.MONTHS[i].toLowerCase()) {
                return i;
            }
        }
        return -1;
    };

    frk.loaderManager = function (el) {
        var count = 0;

//        var mem

        var start = function () {
            count++;
            if (count === 1) {
                $(el).append('<div id="loader" style="background-color:white;position:absolute;width:100%;height:100%;top:0;z-index:100;opacity:0.75;"><div class="loader">Loading...</div></div>');
            }
        };

        var finish = function () {
            count--;

            if (count === 0) {
                window.setTimeout(function () {
                    $(el).find('#loader').remove();
                }, 500);
            }
        };

        return {
            start: start,
            finish: finish
        };
    };

    frk.alert = function (data) {
        if (data.heading || data.body) { // dont show empty alerts
            var html = Handlebars.compile(Handlebars.partials['alert'])(data);
            $('#page-content').prepend(html);
        }
    };
    frk.success = function (heading, body) {
        frk.alert({'alert-type': 'success', 'heading': heading, 'body': body});
    };
    frk.info = function (heading, body) {
        frk.alert({'alert-type': 'info', 'heading': heading, 'body': body});
    };
    frk.warning = function (heading, body) {
        frk.alert({'alert-type': 'warning', 'heading': heading, 'body': body});
    };
    frk.danger = function (heading, body) {
        frk.alert({'alert-type': 'danger', 'heading': heading, 'body': body});
    };

    /**
     * Returns the latest date 
     * @param {array} data An array of objects
     * @param {string} field The date field
     * @returns a date
     */
    frk.getLatest = function (data, field) {
        // the current latest date
        var current;

        for (var d = 0; d < data.length; d++) {
            // get value
            var tmp = frk.getValueByString(data[d], field);
            try {
                //if date
                if(window.Date.parse(tmp)) {
                    if(!current) current = tmp;
                    else {
                        // test
                        if(moment(tmp).isAfter(current)) {
                            current = tmp;
                        }
                    }
                }
            }
            catch(e) {
                
            }
        }
        if(current) return current;

        return false;
    };

    return frk;
})(jQuery, window, document, Handlebars, moment);
